import axios, { AxiosInstance } from 'axios'
import { GenericTypes } from '../types/generic-types'
import {createAuthProvider} from '../providers/auth'

type Constructor = {
  url: string
  authToken: string
}

class GenericTypesService {
  private api: AxiosInstance

  constructor(param: Constructor) {
    this.api = axios.create({
      baseURL: param.url,
      headers: {
        authorization: param.authToken
      }
    })
  }

  async getInstallmentFrequencies(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'PAYMENT_FREQUENCY'
      }
    })

    return data
  }

  async getCountries(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'COUNTRY'
      }
    })

    return data
  }

  async getGeographicSegmentations(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'GEOGRAPHIC_SEGMENTATION'
      }
    })

    return data
  }

  async getPaymentMethods(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'PAYMENT_METHOD'
      }
    })

    return data
  }

  async getSignerTypes(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'SIGNER_TYPE'
      }
    })

    return data
  }

  async getOfferTypes(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'OFFER_TYPE'
      }
    })

    return data
  }

  async getSalesQueueTypes(): Promise<GenericTypes[]> {
    const { data } = await this.api.get('/generic-types', {
      params: {
        type: 'SALES_QUEUE'
      }
    })

    return data
  }
}

export function createGenericTypesService() {
  const authProvider = createAuthProvider()

  if (!process.env.REACT_APP_UTIL_API_URL) {
    throw new Error('EnvNotFound')
  }

  return new GenericTypesService({
    url: process.env.REACT_APP_UTIL_API_URL,
    authToken: `Bearer ${authProvider.getToken()}`
  })
}

